<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="structure-next"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="paragraph-style"><span class="char-style-override">T</span>his book is dedicated to the people that subscribed to my YouTube channel when I first started out. You believed in me when I doubted myself.</p>
<div class="calibre1" id="calibre_pb_3"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NGJobHacks_split_003.vue?6c6e5147